module.exports = __webpack_public_path__ + "img/about-logo.1ce1ad05.png";